import sv from '@drawbotics/drylus-style-vars';

export const greys = {
  title: 'Greys',
  background: sv.grey800,
  description: 'Rarely used and are mostly for utility purpses.',
  colors: [
    {
      name: 'white',
      light: true,
    },
    {
      name: 'grey50',
      light: true,
    },
    {
      name: 'grey100',
      light: true,
    },
    {
      name: 'grey300',
      light: true,
    },
    {
      name: 'grey400',
      light: true,
    },
    {
      name: 'grey500',
    },
    {
      name: 'grey600',
    },
    {
      name: 'grey700',
    },
    {
      name: 'grey800',
    },
    {
      name: 'grey900',
    },
  ],
};

export const neutrals = {
  title: 'Neutrals',
  background: sv.neutralDarker,
  description: 'Neutrals determine backgrounds and other secondary colorations.',
  colors: [
    {
      name: 'neutralLighter',
      light: true,
    },
    {
      name: 'backgroundColor',
      light: true,
    },
    {
      name: 'neutralLight',
      light: true,
    },
    {
      name: 'neutral',
      light: true,
    },
    {
      name: 'neutralDark',
    },
    {
      name: 'neutralDarker',
    },
    {
      name: 'neutralDarkest',
    },
  ],
};

export const azures = {
  title: 'Azures',
  background: sv.azureDark,
  description: 'Azures are used only in forms (borders, backgrounds, etc).',
  colors: [
    {
      name: 'azureLight',
      light: true,
    },
    {
      name: 'azure',
      light: true,
    },
    {
      name: 'azureDark',
    },
  ],
};

export const brands = {
  title: 'Brands',
  background: sv.brand,
  description: 'Used as a highlight when no particular status is required e.g. generic CTAs',
  colors: [
    {
      name: 'brandLighter',
      light: true,
    },
    {
      name: 'brandLight',
      light: true,
    },
    {
      name: 'brand',
    },
    {
      name: 'brandDark',
    },
  ],
};

export const blues = {
  title: 'Blues',
  background: sv.blue,
  description:
    'These are used for neutral information, such as buttons confirming a neutral action (e.g. closing a modal), links, etc.',
  colors: [
    {
      name: 'blueLighter',
      light: true,
    },
    {
      name: 'blueLight',
      light: true,
    },
    {
      name: 'blue',
    },
    {
      name: 'blueDark',
    },
  ],
};

export const reds = {
  title: 'Reds',
  background: sv.red,
  description: 'These are for destructive actions and for errors',
  colors: [
    {
      name: 'redLighter',
      light: true,
    },
    {
      name: 'redLight',
      light: true,
    },
    {
      name: 'red',
    },
    {
      name: 'redDark',
    },
  ],
};

export const oranges = {
  title: 'Oranges',
  background: sv.orange,
  description:
    'Used for actions or elements on the page which the user should be warned/be careful about',
  colors: [
    {
      name: 'orangeLighter',
      light: true,
    },
    {
      name: 'orangeLight',
      light: true,
    },
    {
      name: 'orange',
    },
    {
      name: 'orangeDark',
    },
  ],
};

export const greens = {
  title: 'Greens',
  background: sv.green,
  description:
    'These are for constructive actions, or success events, essentially showing something "good" that happened or is displayed',
  colors: [
    {
      name: 'greenLighter',
      light: true,
    },
    {
      name: 'greenLight',
      light: true,
    },
    {
      name: 'green',
    },
    {
      name: 'greenDark',
    },
  ],
};

export const violets = {
  title: 'Violets',
  background: sv.violet,
  colors: [
    {
      name: 'violetLighter',
      light: true,
    },
    {
      name: 'violetLight',
      light: true,
    },
    {
      name: 'violet',
    },
    {
      name: 'violetDark',
    },
  ],
};

export const purples = {
  title: 'Purples',
  background: sv.purple,
  colors: [
    {
      name: 'purpleLighter',
      light: true,
    },
    {
      name: 'purpleLight',
      light: true,
    },
    {
      name: 'purple',
    },
    {
      name: 'purpleDark',
    },
  ],
};

export const pinks = {
  title: 'Pinks',
  background: sv.pink,
  colors: [
    {
      name: 'pinkLighter',
      light: true,
    },
    {
      name: 'pinkLight',
      light: true,
    },
    {
      name: 'pink',
    },
    {
      name: 'pinkDark',
    },
  ],
};

export const yellows = {
  title: 'Yellows',
  background: sv.yellow,
  colors: [
    {
      name: 'yellowLighter',
      light: true,
    },
    {
      name: 'yellowLight',
      light: true,
    },
    {
      name: 'yellow',
    },
    {
      name: 'yellowDark',
    },
  ],
};